/*
  Flags_v1.js propTypes
  extracted from http://localhost:3000/documentation/resources/oaspec.json
  on 2018-04-23T13:43:27.206Z
*/

import { bool } from 'prop-types'

export default {
  bio: bool,
  veterinaryDrug: bool,
  vegetarian: bool,
  vegan: bool,
  refrigerated: bool,
  prescriptionMedicine: bool,
  medicament: bool,
  homeopathic: bool,
  herbal: bool,
}
